import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  activityDeleteModal: {
    isOpen: false,
    deletePath: "",
  },
};

const slice = createSlice({
  name: "modals",
  initialState,

  reducers: {
    setActivityDeleteModal: (state, action) => {
      state.activityDeleteModal.isOpen = action.payload;
    },
    setActivityDeletePath: (state, action) => {
      state.activityDeleteModal.deletePath = action.payload;
    },
  },
});

export const { setActivityDeletePath, setActivityDeleteModal } = slice.actions;
export default slice.reducer;
